// Client-side service that calls our secure serverless API
// The API key is kept secure on the server side
const API_ENDPOINT = '/api/analyze-card';

/**
 * Convert image file to base64 for GPT-4o Vision API
 */
const imageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Analyze business card using GPT Vision (gpt-4o-mini by default)
 */
export const analyzeBusinessCardWithGPT = async (imageFile, conventionName = 'CES 2026', backImageFile = null) => {
  try {
    console.log('Starting GPT Vision analysis...');
    const base64Image = await imageToBase64(imageFile);
    console.log('Front image converted to base64, size:', base64Image.length);
    
    let base64BackImage = null;
    if (backImageFile) {
      base64BackImage = await imageToBase64(backImageFile);
      console.log('Back image converted to base64, size:', base64BackImage.length);
    }
    
    console.log('Sending request to secure API endpoint...');
    
    // Call our serverless API endpoint (API key is secure on server side)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 second timeout

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        base64Image,
        base64BackImage,
        conventionName,
      }),
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `API error: ${response.status}`);
    }
    
    console.log('Received response from secure API endpoint');
    const parsedData = await response.json();
    return parsedData;
  } catch (error) {
    console.error('API Error:', error);
    
    if (error.name === 'AbortError') {
      throw new Error('Request timeout: The analysis took too long. Please try again.');
    } else if (error.message) {
      throw error; // Re-throw if it's already an Error with message
    } else {
      throw new Error(`Error: ${error.message || 'Failed to analyze image'}`);
    }
  }
};

